var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/evaluation.4bb8a007.png","uri@2x": __webpack_public_path__ + "static/media/evaluation.3e487b73.png","uri@3x": __webpack_public_path__ + "static/media/evaluation.119fbac9.png",
    width: 137,
    height: 136
});